import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useCustomersUIContext } from "../CustomersUIContext";

const prepareFilter = (queryParams, values) => {
  const { status, type, searchText } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by status
  filter.status = status !== "" ? +status : undefined;
  // Filter by type
  const type1 = type !== "" ? +type : 0;
  // Filter by all fields
  if (searchText) {
    if (type1 === 0) {
      filter.username = searchText;
    } else if (type1 === 1) {
      filter.ipSignup = searchText;
    } else if (type1 === 2) {
      filter.visitorId = searchText;
    } else if (type1 === 3) {
      filter._id = searchText;
    } else if (type1 === 4) {
      filter.referedBy = searchText;
    } else if (type1 === 5) {
      filter.deviceName = searchText;
    } else if (type1 === 6) {
      filter.androidId = searchText;
    } else if (type1 === 7) {
      filter.fingerPrintId = searchText;
    }
  }
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function CustomersFilter({ listLoading }) {
  let timer;
  // Customers UI Context
  const customersUIContext = useCustomersUIContext();
  const customersUIProps = useMemo(() => {
    return {
      queryParams: customersUIContext.queryParams,
      setQueryParams: customersUIContext.setQueryParams,
    };
  }, [customersUIContext]);

  // queryParams, setQueryParams,
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(customersUIProps.queryParams, values);
    if (!isEqual(newQueryParams, customersUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      // update list by queryParams
      customersUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          status: "", // values => All=""/Susspended=0/Active=1/Pending=2
          type: "", // values => All=""/Business=0/Individual=1
          searchText: "",
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="status"
                  placeholder="Filter by Status"
                  // TODO: Change this code
                  onChange={(e) => {
                    setFieldValue("status", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.status}
                >
                  <option value="">All</option>
                  <option value="2">Banned</option>
                  <option value="3">Active</option>
                  <option value="4">Deleted</option>
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Status
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  placeholder="Choose Filter Field"
                  name="type"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("type", e.target.value);
                    handleSubmit();
                  }}
                  value={values.type}
                >
                  <option value="0">Email</option>
                  <option value="1">IP of Signup</option>
                  <option value="2">Visitor ID</option>
                  <option value="3">ID</option>
                  <option value="4">Refered by</option>
                  <option value="5">Device Name</option>
                  <option value="6">Android ID</option>
                  <option value="7">FingerPrint device</option>
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Field
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchText"
                  placeholder="Search"
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue("searchText", e.target.value);
                    clearTimeout(timer);
                    timer = setTimeout(() => {
                      console.log("reee")
                      handleSubmit();
                    }, [500]);
                  }}
                />
                <small className="form-text text-muted">
                  <b>Search</b> in the specific field
                </small>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
